var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.75,
    y: 56.25,
    width: 40.5,
    height: 13.5,
    rx: 4.5,
    stroke: "#1F1F1F",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 2.25H5.319C3.62404 2.25 2.25 3.62404 2.25 5.319C2.25 23.9586 17.3604 39.069 36 39.069C54.6396 39.069 69.75 23.9586 69.75 5.319C69.75 4.50505 69.4267 3.72444 68.8511 3.14889C68.2756 2.57334 67.4949 2.25 66.681 2.25H47.25",
    stroke: "#1F1F1F",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6509 38.4722L24.4219 56.2502H46.9219L42.1939 38.5022",
    stroke: "#1F1F1F",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7947 3.22506L41.5387 10.5991H47.9197C48.6371 10.5847 49.2906 11.01 49.5679 11.6718C49.8452 12.3336 49.6901 13.0977 49.1767 13.5991L43.3087 19.3561L46.5547 26.8111C46.8474 27.5117 46.6599 28.321 46.0888 28.8214C45.5177 29.3218 44.6907 29.4013 44.0347 29.0191L36.1897 24.6001L28.3447 29.0191C27.6888 29.399 26.8636 29.3182 26.2938 28.8184C25.7239 28.3185 25.5364 27.5109 25.8277 26.8111L29.0737 19.3561L23.2147 13.5901C22.7008 13.0883 22.5459 12.3235 22.824 11.6614C23.1021 10.9992 23.7567 10.5744 24.4747 10.5901H30.8527L34.5997 3.21606C34.911 2.62061 35.528 2.24811 36.1999 2.25001C36.8718 2.2519 37.4868 2.62787 37.7947 3.22506Z",
    stroke: "#3FB483",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.e083409ed728c5fc93d3810d7baaca13.svg";
export { ForwardRef as ReactComponent };